module.exports = "<h6>{{title}}</h6>\n<div class=\"pieContainer\"\n     #pieContainer>\n  <canvas #chart> </canvas>\n</div>\n"